import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const Marche = ({
  width = 75,
  height = 75,
  className,
  color,
  decorative = false,
  ariaLabel = "Marche",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 192.756 192.756"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 0h192.756v192.756H0z"
        clipRule="evenodd"
      ></path>
      <path d="M142.32 60.92v62.754c0 6.93-6.113 13.523-13.682 13.523a13.5 13.5 0 0 1-9.562-3.961 13.48 13.48 0 0 1-3.961-9.562V91.825l-8.586 8.585-18.555-18.555L117.58 51.97c2.967-2.996 7.336-5.714 11.506-5.938 3.266-.178 6.512.931 9.141 3.558l-.006.004c3.431 3.434 4.099 7.042 4.099 11.326"></path>
      <path
        fill="#37844f"
        d="M161.936 115.199c0 17.822-7.107 32.672-18.658 43.225-11.881 10.85-28.418 17.018-46.636 17.018s-34.756-6.168-46.636-17.018c-11.553-10.551-18.66-25.402-18.66-43.225l-.072-38.312h13.893l.072 38.312c0 13.674 5.372 24.994 14.102 32.967 9.341 8.533 22.566 13.383 37.301 13.383 14.733 0 27.96-4.85 37.3-13.383 8.73-7.973 14.102-19.293 14.102-32.967l.158-83.992H45.081l.047 24.749-13.875 11.017-.079-42.712-.014-6.947h130.96l-.012 6.947z"
      ></path>
      <path d="M64.644 69.308a9.95 9.95 0 0 0 7.056-2.922 9.95 9.95 0 0 0 2.922-7.055c0-2.756-1.117-5.25-2.922-7.055s-4.3-2.921-7.056-2.921a9.95 9.95 0 0 0-7.055 2.921 9.95 9.95 0 0 0-2.921 7.055 9.95 9.95 0 0 0 2.921 7.055 9.94 9.94 0 0 0 7.055 2.922m8.868 51.84v-7.467a30.4 30.4 0 0 1-7.802-20.375 30.4 30.4 0 0 1 7.802-20.371v-1.471a14.96 14.96 0 0 1-8.869 2.896c-2.146 0-4.189-.452-6.038-1.263h-2.748v50.576c0 2.426.984 4.623 2.573 6.213s3.787 2.572 6.212 2.572c2.427 0 4.625-.982 6.214-2.572s2.573-3.787 2.573-6.213v-2.525zm5.052-2.959v8.009h-.311a13.8 13.8 0 0 1-3.824 7.258 13.8 13.8 0 0 1-9.786 4.055 13.8 13.8 0 0 1-9.784-4.055 13.8 13.8 0 0 1-4.054-9.783V73.098h-20.17l4.976-4.411L50 55.933a15 15 0 0 1 4.017-7.227 14.98 14.98 0 0 1 10.626-4.403c4.151 0 7.908 1.682 10.627 4.403a14.98 14.98 0 0 1 4.403 10.626c0 2.008-.395 3.925-1.11 5.677v9.231l37.023 39.151 1.871 1.979-2.127 1.713a30.5 30.5 0 0 1-8.98 5.002l.002.004a30.5 30.5 0 0 1-10.133 1.729 30.4 30.4 0 0 1-17.655-5.629M50.806 68.045v-2.841a15 15 0 0 1-.819-2.533l-6.064 5.375h6.883zm24.766 10.364a25.4 25.4 0 0 0-3.128 5.771 25.5 25.5 0 0 0-1.68 9.126c0 7.03 2.85 13.395 7.456 18a25.4 25.4 0 0 0 12.781 6.92l-10.756-10.6 3.533-3.592 14.631 14.42-.23.232a26 26 0 0 0 3.078-.42l-15.683-16.049 3.612-3.512 17.44 17.848a25.5 25.5 0 0 0 3.32-1.797z"></path>
    </svg>
  );
};

